// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"275":"0cdbe39d","538":"d2e86bc6"}[chunkId] + ".css";
};